export const countryCodes = {
  AUSTRALIA: 'AUS',
  UNITED_STATES: 'USA'
};
